import { render, staticRenderFns } from "./schoolpage.vue?vue&type=template&id=3e2fbb0e&scoped=true"
import script from "./schoolpage.vue?vue&type=script&lang=js"
export * from "./schoolpage.vue?vue&type=script&lang=js"
import style0 from "./schoolpage.vue?vue&type=style&index=0&id=3e2fbb0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2fbb0e",
  null
  
)

export default component.exports